import { Assets } from 'pixi.js';
import { sound } from '@pixi/sound';
import { BaseSoundService } from './index';
import { loadingStore } from '../../store/loadingStore';

export const PixiAssets = Assets;
let pauseTimeOutId = null;
export const SoundTypes = {
  ReelStop: 'reelStop',
  BackgroundMusic: 'music',
  dollarScatterWin: 'dollarScatterWin',
  starScatterWin: 'starScatterWin',
  SpinButton: 'SpinButton',
  WildSymbol: 'WildSymbol',
  WildOpeningSound: 'WildOpeningSound',
  WinAccumulationSound: 'WinAccumulationSound',
  WinningLineSound: 'WinningLineSound',
  WinPopupBigWin: 'WinPopupBigWin',
  WinPopupEpicWin: 'WinPopupEpicWin',
  WinPopupMegaWin: 'WinPopupMegaWin',
  WinPopupSuperWin: 'WinPopupSuperWin',
  JackpotSymbolSound: 'JackpotSound',
  JackpotSymbol: 'JackpotSymbol',
  JackpotBackground: 'background',
  JackpotIlluminations: 'illuminations',
  JackpotSceneTransition: 'sceneTransition',
  JackpotSuitAppearance: 'suitAppearance',
  JackpotSuitTransfer: 'suitTransfer',
  JackpotWinPopUp: 'winPopUp',
  WheelSpinning: 'wheelSpinning',
  WheelWinPopup: 'wheelWinPopup',
  OpenWheel: 'openWheel',
  SpinWheelButton: 'spinWheelButton',
};

export const soundOptions = [
  {
    src: 'sounds/spinWheelButton.mp3',
    path: 'sounds/spinWheelButton.mp3',
    name: SoundTypes.SpinWheelButton,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/wheelSpinning.mp3',
    path: 'sounds/wheelSpinning.mp3',
    name: SoundTypes.WheelSpinning,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/wheelWinPopup.mp3',
    path: 'sounds/wheelWinPopup.mp3',
    name: SoundTypes.WheelWinPopup,
    autoplay: false,
    loop: true,
    html5: true,
  },
  {
    src: 'sounds/openWheel.mp3',
    path: 'sounds/openWheel.mp3',
    name: SoundTypes.OpenWheel,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/ReelStop.mp3',
    path: 'sounds/ReelStop.mp3',
    name: SoundTypes.ReelStop,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/dollarScatterWin.mp3',
    path: 'sounds/dollarScatterWin.mp3',
    name: SoundTypes.dollarScatterWin,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/starScatterWin.mp3',
    path: 'sounds/starScatterWin.mp3',
    name: SoundTypes.starScatterWin,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/SpinButton.mp3',
    path: 'sounds/SpinButton.mp3',
    name: SoundTypes.SpinButton,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/WildSymbol.mp3',
    path: 'sounds/WildSymbol.mp3',
    name: SoundTypes.WildSymbol,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/WildOpeningSound.mp3',
    path: 'sounds/WildOpeningSound.mp3',
    name: SoundTypes.WildOpeningSound,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/WinAccumulationSound.mp3',
    path: 'sounds/WinAccumulationSound.mp3',
    name: SoundTypes.WinAccumulationSound,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/WinningLineSound.mp3',
    path: 'sounds/WinningLineSound.mp3',
    name: SoundTypes.WinningLineSound,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/background.mp3',
    path: 'sounds/background.mp3',
    name: SoundTypes.BackgroundMusic,
    autoplay: false,
    loop: true,
    html5: true,
  },
  {
    src: 'sounds/WinPopupBigWin.mp3',
    path: 'sounds/WinPopupBigWin.mp3',
    name: SoundTypes.WinPopupBigWin,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/WinPopupMegaWin.mp3',
    path: 'sounds/WinPopupMegaWin.mp3',
    name: SoundTypes.WinPopupMegaWin,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/WinPopupSuperWin.mp3',
    path: 'sounds/WinPopupSuperWin.mp3',
    name: SoundTypes.WinPopupSuperWin,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/WinPopupEpicWin.mp3',
    path: 'sounds/WinPopupEpicWin.mp3',
    name: SoundTypes.WinPopupEpicWin,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/jackpotSounds/JackpotSymbolSound.mp3',
    path: 'sounds/jackpotSounds/JackpotSymbolSound.mp3',
    name: SoundTypes.JackpotSymbolSound,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/jackpotSounds/backgroundMusic.mp3',
    path: 'sounds/jackpotSounds/backgroundMusic.mp3',
    name: SoundTypes.JackpotBackground,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/jackpotSounds/illuminations.mp3',
    path: 'sounds/jackpotSounds/illuminations.mp3',
    name: SoundTypes.JackpotIlluminations,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/jackpotSounds/sceneTransition.mp3',
    path: 'sounds/jackpotSounds/sceneTransition.mp3',
    name: SoundTypes.JackpotSceneTransition,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/jackpotSounds/suitAppearance.mp3',
    path: 'sounds/jackpotSounds/suitAppearance.mp3',
    name: SoundTypes.JackpotSuitAppearance,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/jackpotSounds/suitTransfer.mp3',
    path: 'sounds/jackpotSounds/suitTransfer.mp3',
    name: SoundTypes.JackpotSuitTransfer,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/jackpotSounds/winPopUp.mp3',
    path: 'sounds/jackpotSounds/winPopUp.mp3',
    name: SoundTypes.JackpotWinPopUp,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/jackpotSounds/Jackpot_Symbol.mp3',
    path: 'sounds/jackpotSounds/Jackpot_Symbol.mp3',
    name: SoundTypes.JackpotSymbol,
    autoplay: false,
    html5: true,
  },
];

const SoundListNames = soundOptions.map((el) => el.name);

class SoundService extends BaseSoundService {
  constructor(props) {
    super(props);
    this.loadedResourceKeys = [];
  }

  allResourceDynamicLoader(pixiAssets) {
    return pixiAssets.load(this.loadedResourceKeys);
  }

  loadResource = (resources = soundOptions) => {
    // return new Promise((resolve, reject) => {
    resources.forEach((item) => {
      PixiAssets.add(item.name, item.path, item.config);
      this.loadedResourceKeys.push(item.name);
    });
    this.allResourceDynamicLoader(PixiAssets)
      .then((res) => {
        this.playMusic();
        loadingStore.updateLoading({ isSoundLoaded: true });
      })
      .catch(() => {
        loadingStore.updateLoading({ isSoundLoaded: true });
      });
    // });
  };

  async play(name, config = {}) {
    return PixiAssets.get(name).play(config);
  }

  stop(name = '') {
    if (name) return PixiAssets.get(name).stop();
  }

  stopAll() {
    const SoundList = Object.values(
      PixiAssets.get(SoundListNames.filter((el) => el !== SoundTypes.BackgroundMusic))
    );
    SoundList.forEach((el) => {
      el.stop();
    });
  }

  playMusic() {
    return this.play(SoundTypes.BackgroundMusic, { loop: true });
  }

  changeMusicVolume(volume) {
    PixiAssets.get(SoundTypes.BackgroundMusic).volume = volume;
  }

  changeSoundsVolume(volume) {
    this.soundOptions.forEach(({ name }) => {
      if (this.sounds[name]) {
        this.sounds[name].volume(volume);
      }
    });
  }

  changeSoundAndMusicVolume(value) {
    sound.volumeAll = value;
    // this.changeSoundsVolume(value);
    // this.changeMusicVolume(value);
  }

  pauseSounds() {
    clearTimeout(pauseTimeOutId);
    sound.pauseAll();
  }

  resumeSounds() {
    clearTimeout(pauseTimeOutId);
    pauseTimeOutId = setTimeout(() => {
      sound.resumeAll();
    }, 1500);
  }
}

const soundService = new SoundService({
  options: soundOptions,
});

export { SoundTypes as soundTypes, soundService };
